import React, { useState, useEffect } from "react";
import ReactSelect from "react-select";
import Chart from "react-apexcharts";
import {
  Card,
  CardBody,
  CardHeader,
  CardHeaderToolbar
} from "../../../../../_metronic/_partials/controls";
import { CircularProgress } from "@material-ui/core";
import { currencyFormatter } from "../../../../../_metronic/_helpers";

const months = [
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "Mei",
  "Jun",
  "Jul",
  "Aug",
  "Sep",
  "Oct",
  "Nov",
  "Des"
];

const chart = {
  chart: {
    id: "basic-bar",
    type: "line"
  },
  colors: ["#FF1654", "#247BA0"],
  markers: {
    size: 5
  },
  stroke: {
    width: 5
  },
  xaxis: {},
  yaxis: {
    type: "numeric"
  }
};

export const OrganizationGrowthCharts = ({
  loading = false,
  organization_growth = [],
  consolidation_growth = [],
  params,
  updateParams
}) => {
  const [xaxis, setXaxis] = useState([]);
  const [orgSeries, setOrgSeries] = useState([]);
  const [consdSeries, setConsdSeries] = useState([]);

  function getChartOptions(params, isOrgSeries) {
    if (params.period_type === "year") {
      const options = {
        ...chart,
        colors: isOrgSeries ? ["#FF1654"] : ["#247BA0"],
        xaxis: {
          categories: isOrgSeries ? orgSeries.map(v => v.x) : consdSeries.map(v => v.x),
        },
        yaxis: {
          labels: {
            formatter: value => isOrgSeries ? value : currencyFormatter(value)
          }
        }
      };
  
      return options;
    }
  }

  useEffect(() => {
    setOrgSeries(
      organization_growth.map(({ count, year, month }) => ({
        x: `${months[month - 1]} - ${year}`,
        y: +count
      }))
    );

    setConsdSeries(
      consolidation_growth.map(({ total_amount, year, month }) => ({
        x: `${months[month - 1]} - ${year}`,
        y: (+total_amount || 0) === 0 ? 0 : parseFloat(total_amount)
      }))
    );
  }, [organization_growth, consolidation_growth]);

  return (
    <Card>
      <CardHeader title="Perkembangan Lembaga">
        <CardHeaderToolbar>
          {loading && <CircularProgress color="inherit" size={18} />}
        </CardHeaderToolbar>
      </CardHeader>
      <CardBody>
        <div className="row mb-5 d-flex justify-content-end">
          <div className="col-6">
            <label htmlFor="period_type">Periode</label>
            <ReactSelect
              name="period_type"
              options={[
                { label: "5 Bulan", value: "month" },
                { label: "5 Tahun", value: "year" }
              ]}
              value={{
                label: params.period_name,
                value: params.period_type
              }}
              onChange={selected => {
                const { label = "", value = "" } = selected ?? {};

                updateParams({ period_name: label, period_type: value });
              }}
            />
          </div>
        </div>
        <div className="row">
          <div className="col">
            <h6>Jumlah Lembaga Aktif</h6>
            <Chart
              options={getChartOptions(params, true)}
              height="300"
              series={[
                { name: "Jumlah Lembaga Aktif", data: orgSeries },
              ]}
            />
          </div>
          <div className="col">
          <h6>Konsolidasi (Dalam Juta)</h6>
            <Chart
              options={getChartOptions(params, false)}
              height="300"
              series={[
                { name: "Konsolidasi (Dalam Juta)", data: consdSeries }
              ]}
            />
          </div>
        </div>
      </CardBody>
    </Card>
  );
};
